import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect(): void {
    this.updateOpenState()
    window.addEventListener("resize", this.updateOpenState.bind(this))
  }

  disconnect(): void {
    window.removeEventListener("resize", this.updateOpenState.bind(this))
  }

  private updateOpenState(): void {
    const details = this.element as HTMLDetailsElement
    details.open = window.innerWidth >= 1024
  }
}
